import React from "react";
import { NavLink } from "react-router-dom";
import "../../styles/CTASection.css";

const CTASection = () => {
    return (
        <div className="cta-section">
            <div className="cta-content">
                <h2 className="cta-title">Let’s Build Your First AI Automation</h2>
                <p className="cta-description">
                    Book a free consultation call and we’ll walk you through real automation opportunities for your business —
                    tailored to your goals, tools, and team.
                    <br />
                    <strong>No pressure. No fluff. Just actionable strategy.</strong>
                </p>
                <NavLink to="/contact" className="cta-button">
                    Book a Free Consultation
                </NavLink>
            </div>
        </div>
    );
};

export default CTASection;
